import { Grid } from "antd";

export const useIsScreenLargerThanMd = () => {
  const breakpoints = Grid.useBreakpoint();
  return !!breakpoints.md;
};
